import { Component, Input } from '@angular/core';
import { FormGroup } from '@angular/forms';
import { IDisplayData, ReactionTypeEnum } from '@whetstoneeducation/hero-common';
import { BaseComponent } from '../../../../shared/base-classes/base.component';
import { BehaviorSubject } from 'rxjs';

@Component({
  selector: 'app-default-reaction',
  templateUrl: './default-reaction.html',
  styleUrls: ['./default-reaction.scss']
})
export class AppDefaultReactionComponent extends BaseComponent {
  @Input() defaultBehaviorCodeReactionForm: FormGroup;
  @Input() reactionOptions: IDisplayData[];
  @Input() title: string;
  
  public noReactionOption: IDisplayData;

  public isDefault: BehaviorSubject<boolean> = new BehaviorSubject(true);
  public displayTriggerCount: BehaviorSubject<boolean> = new BehaviorSubject(false);
  public triggerCountDefaults = {
    [ReactionTypeEnum.DEFAULT]: 0,
    [ReactionTypeEnum.ASSIGN_AT]: 1,
    [ReactionTypeEnum.SELECT_MENU]: null,
  };

  constructor() {
    super();
  }

  public ngOnInit(){
    this.noReactionOption = this.reactionOptions.filter((option) =>  option.display === 'No Reaction')[0];
  }

  public ngAfterViewInit() {
    // Set default reaction type
    this.defaultBehaviorCodeReactionForm.get('reactionType').setValue(ReactionTypeEnum.DEFAULT);
    this.defaultBehaviorCodeReactionForm.get('triggerCount').setValue(this.triggerCountDefaults[ReactionTypeEnum.DEFAULT]);
  }

  public setReaction(id: string) {
    this.defaultBehaviorCodeReactionForm.get('reactionId').setValue(id);
  }

  public updateReactionType(value: string) {
    this.displayTriggerCount.next(value === ReactionTypeEnum.ASSIGN_AT);
    this.isDefault.next(value === ReactionTypeEnum.DEFAULT);
    this.defaultBehaviorCodeReactionForm.get('active').setValue(value !== ReactionTypeEnum.DEFAULT);

    // Update the trigger count to match the reaction type
    if (value in this.triggerCountDefaults) {
      const defaultTriggerCount = this.triggerCountDefaults[value];
      this.defaultBehaviorCodeReactionForm.get('triggerCount').setValue(defaultTriggerCount);
    }
  }
}
